/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - Picture</b>: Картинка</li>\n<li><b>2 - Track</b>: Аудио-файл</li>\n<li><b>3 - Document</b>: Документ</li>\n</ul>\n
 */
export const fileTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Picture</b>: Картинка</li>\n<li><b>2 - Track</b>: Аудио-файл</li>\n<li><b>3 - Document</b>: Документ</li>\n</ul>\n")